import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-one-page',
  templateUrl: './team-one-page.component.html',
  styleUrls: ['./team-one-page.component.scss']
})
export class TeamOnePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
